import { refreshToken } from "@/Services/TherapyApi/Auth";

import { useAuthStore } from "@/Modules/Auth/Store";

import { danger } from "@/Utils/Debug";
import { isValidString } from "@/Utils/String";

async function refreshTokenAH(): Promise<boolean> {
  const authStore = useAuthStore();
  const token = authStore.userToken ?? "";

  try {
    if (isValidString(token)) {
      const refreshTokenApiResponse = await refreshToken(token);

      authStore.userToken = refreshTokenApiResponse.token;

      return true;
    } else {
      return handleError();
    }
  } catch (error: unknown) {
    return handleError(error);
  }
}

function handleError(error?: unknown): boolean {
  const authStore = useAuthStore();

  danger("Error refresh token", error);
  authStore.logout();

  return false;
}

export default refreshTokenAH;
